import getEnv from './getEnv';

export const isLocal = (() => {
  const { REACT_APP_STAGE } = getEnv();
  return REACT_APP_STAGE === 'local';
})();
